import { render, staticRenderFns } from "./edit-qaqc.vue?vue&type=template&id=535327cc&"
import script from "./edit-qaqc.vue?vue&type=script&lang=ts&"
export * from "./edit-qaqc.vue?vue&type=script&lang=ts&"
import style0 from "./edit-qaqc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports